module.exports = __webpack_public_path__ + "static/media/call-mbb.24aa36f7.svg";